import { freeze } from 'icepick';
import { SET_DATA, type SetDataAction } from '../../../actions/app';
import type { ReportsState } from './types';

type Action = SetDataAction;

const defaultState: ReportsState = {};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: ReportsState = defaultState, action: Action): ReportsState => {
	switch (action.type) {
		case SET_DATA:
			return freeze(
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				action.payload.reduce<Record<string, any>>(
					(result, item) => ({
						// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
						...result,
						[item.reportKey]: item,
					}),
					{},
				),
			);
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
